module.exports = __webpack_public_path__ + "img/scene-bg.a7a83afb.png";